import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ETSY_NOTICE =
  "The term 'Etsy' is a trademark of Etsy, Inc. This application uses the Etsy API but is not endorsed or certified by Etsy.";

export const Brand = ({ to = "/" }) => (
  <Link to={to} data-testid="brand-logo-link" aria-label="AetherTags home" className="group flex min-h-[44px] items-center gap-3">
    <span className="relative grid h-9 w-9 sm:h-11 sm:w-11 shrink-0 place-items-center">
      <span className="absolute inset-0 rounded-full bg-[conic-gradient(from_200deg,#E9C98B,#8B7CFF,#5EE6D0,#E9C98B)] opacity-70 blur-[10px] transition-opacity duration-700 group-hover:opacity-100" />
      <span className="absolute inset-0 rounded-full bg-[conic-gradient(from_200deg,#F3DDAE,#E9C98B,#8B7CFF,#E9C98B,#F3DDAE)] p-px">
        <span className="block h-full w-full rounded-full bg-[radial-gradient(circle_at_30%_25%,#1D1A3F,#0A0B16_70%)]" />
      </span>
      <span className="relative font-display text-[1.35rem] sm:text-[1.7rem] italic leading-none text-aurora transition-transform duration-700 group-hover:scale-110">A</span>
    </span>
    <span className="font-display text-[1.45rem] sm:text-[1.85rem] leading-none tracking-[-0.03em] text-[#F4F1EA]">
      Aether<span className="italic bg-gradient-to-r from-[#F3DDAE] via-[#E9C98B] to-[#C2BAFF] bg-clip-text text-transparent pr-0.5">Tags</span>
    </span>
  </Link>
);

export const SiteFooter = ({ hideFounding = false }) => {
  const { user } = useAuth();
  const links = [["/tools", "Free tools", "tools"], ["/blog", "Guides", "guides"], ["/etsy-tags", "Etsy Tags", "etsy-tags"], ["/about", "About", "about"], ["/sitemap", "Sitemap", "sitemap"],
    ...(hideFounding ? [] : [["/founding", "Founding members", "founding"]]), ...(user ? [] : [["/login", "Log in", "login"]]),
    ["/policies/terms", "Terms", "policy-terms"], ["/policies/privacy", "Privacy", "policy-privacy"],
    ["/policies/refund", "Refund & Cancellation", "policy-refund"], ["/policies/cookie", "Cookies", "policy-cookie"]];
  return (
  <footer data-testid="site-footer" className={`relative ${hideFounding ? "mt-12" : "mt-28"} border-t border-white/[0.07]`}>
    <div className="pointer-events-none absolute inset-x-0 -top-px h-px bg-gradient-to-r from-transparent via-[#E9C98B]/55 to-transparent" />
    <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8 grid gap-8 md:grid-cols-[1fr_auto] md:items-end">
      <div className="space-y-4">
        <Brand />
        <p data-testid="etsy-trademark-notice" className="max-w-2xl text-[13px] text-muted-foreground leading-relaxed">
          {ETSY_NOTICE}
        </p>
        <p className="text-xs text-muted-foreground/80">
          AetherTags never promises rankings, traffic or sales. Results are associated with changes, not guaranteed.
        </p>
      </div>
      <nav aria-label="Footer" className="flex flex-wrap gap-x-5 text-[13px] text-muted-foreground">
        {links.map(([to, l, id]) => (
          <Link key={to} to={to} data-testid={`footer-${id}`} className="inline-flex min-h-[44px] min-w-[44px] items-center hover:text-foreground transition-colors">
            {l}
          </Link>
        ))}
      </nav>
    </div>
  </footer>
  );
};
